(() => {
  const THRESHOLD = 2500;
  const DISCOUNT = 500;

  function formatMoney(value) {
    return `₹${Math.round(value)}`;
  }

  async function updateProgress() {
    // const container = document.getElementById('cart-discount-progress');
    // if (!container) return;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const total = cart.original_total_price / 100;
      const remaining = Math.max(THRESHOLD - total, 0);
      const percent = Math.min((total / THRESHOLD) * 100, 100);

      // const fill = document.getElementById('cdp-bar-fill');
      // const totalEl = document.getElementById('cdp-total');
      // const msg = document.getElementById('cdp-message');

      // if (!fill || !totalEl || !msg) return;

      /*
      fill.style.cssText = `
  width: ${percent}%;
  height: 6px;
  background: #000;
  display: block;
  position: relative;
  z-index: 10;
`;


      if (remaining > 0) {
  container.classList.remove('unlocked');
} else {
  container.classList.add('unlocked');
}



      totalEl.textContent = formatMoney(total);

      if (remaining > 0) {
        msg.innerHTML = `🎁 Unlock ₹500 OFF! Add <strong>${formatMoney(remaining)}</strong>  more to your cart & get
 <strong>₹${DISCOUNT} off</strong> on this order.`;
      } else {
        msg.innerHTML = `🎉 Congratulations! You've unlocked <strong>₹${DISCOUNT} off.</strong>`;
      }
        */
    } catch (e) {
      console.error('Cart progress error:', e);
    }
  }

  // INITIAL LOAD
  document.addEventListener('DOMContentLoaded', updateProgress);

  // SHOPIFY CART EVENTS (THIS IS THE KEY)
  document.addEventListener('cart:updated', updateProgress);
  document.addEventListener('cart:refresh', updateProgress);

  // FALLBACK: intercept fetch cart updates
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {
      if (
        typeof arguments[0] === 'string' &&
        arguments[0].includes('/cart/')
      ) {
        setTimeout(updateProgress, 200);
      }
      return response;
    });
  };
})();
